import { Action, createAsyncAction, createReducer } from 'typesafe-actions';
import { produce } from 'immer';
import type { ReduxError } from '@universal/errors';
import { GlobalSettingsType } from '../../../../types/globalSettingsType';

// Actions
export enum Actions {
  GET_GLOBALSETTINGS = 'naf/globalSettings/GET_GLOBALSETTINGS',
  GET_GLOBALSETTINGS_SUCCESS = 'naf/globalSettings/GET_GLOBALSETTINGS_SUCCESS',
  GET_GLOBALSETTINGS_FAIL = 'naf/globalSettings/GET_GLOBALSETTINGS_FAIL',
  GET_GLOBALSETTINGS_CANCEL = 'naf/globalSettings/GET_GLOBALSETTINGS_CANCEL',
}

export interface State {
  isUpdating: boolean;
  // Fetched at most once on the client: Navbar/Footer/SystemMessage request it whenever a field is
  // missing, which looped when the CMS response lacked one.
  hasFetched?: boolean;
  settings: GlobalSettingsType;
  errorState?: ReduxError;
}

export const initialState: State = {
  settings: {
    title: '',
    megaMenu: {},
    profileMenu: [],
  },
  isUpdating: false,
};

export const actions = {
  getGlobalSettings: createAsyncAction(
    Actions.GET_GLOBALSETTINGS, // request payload creator
    Actions.GET_GLOBALSETTINGS_SUCCESS, // success payload creator
    Actions.GET_GLOBALSETTINGS_FAIL, // failure payload creator
    Actions.GET_GLOBALSETTINGS_CANCEL, // optional cancel payload creator
  )<string, GlobalSettingsType, [ReduxError, { id: string }]>(),
};

export const reducers = createReducer<State, Action>(initialState, {})
  .handleAction(actions.getGlobalSettings.request, (state = initialState) =>
    produce(state, (draftState) => {
      if (!state.hasFetched) draftState.isUpdating = true;
    }),
  )
  .handleAction(actions.getGlobalSettings.success, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.settings = action.payload;
      draftState.isUpdating = false;
      draftState.hasFetched = true;
    }),
  )
  .handleAction(actions.getGlobalSettings.failure, (state = initialState, action) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
      draftState.hasFetched = true;
      draftState.errorState = action.payload;
    }),
  )
  .handleAction(actions.getGlobalSettings.cancel, (state = initialState) =>
    produce(state, (draftState) => {
      draftState.isUpdating = false;
    }),
  );
